import { render, staticRenderFns } from "./WhatsappIntegrationWidget.vue?vue&type=template&id=f8c69038"
import script from "./WhatsappIntegrationWidget.vue?vue&type=script&lang=js"
export * from "./WhatsappIntegrationWidget.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIntegrationWidget.vue?vue&type=style&index=0&id=f8c69038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports